import AxiosClient from "../../../services/axios.services";

class ExcelMassiveUploadServices {
  saveExcelMassiveUpload = (data) =>
    AxiosClient.post("/api/app/Funcional_Check_List_carga_masiva/", data, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new ExcelMassiveUploadServices();
